import BaseApi from '../base'

const path = '/synergy/employee-leave'
class EmployeeLeaveApi extends BaseApi {
  constructor() {
    super(path)
  }

  batchApproval = (list) => this.put(`${path}/batch-approval`, list)
  getStat = (params) => this.get(`${path}/stat`, params)
  // 批量新增请假记录
  batchAdd = (list) => this.post(`${path}/batch-add`, list)
}

export default new EmployeeLeaveApi()
